import { useRef } from 'react';

// One backdrop and one motion for every overlay (KoobModal, KoobSlideOver,
// KoobDrawer, KoobLoadingOverlay), so they open and close the same way.
// Spread the transitions on a Headless UI `Transition` or `Transition.Child`.

export const overlayBackdrop = 'bg-k-h/55 backdrop-blur-sm';

/** The title of a side panel (KoobSlideOver, KoobDrawer): the UI kit's H2. */
export const overlayTitle = 'm-0 text-xl font-semibold text-k-h break-words';

export const fadeTransition = {
  enter: 'transition-opacity ease-out duration-200',
  enterFrom: 'opacity-0',
  enterTo: 'opacity-100',
  leave: 'transition-opacity ease-in duration-150',
  leaveFrom: 'opacity-100',
  leaveTo: 'opacity-0',
};

/** A centred panel: rises on phones, grows on larger screens. */
export const popTransition = {
  enter: 'transition ease-out duration-200',
  enterFrom: 'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95',
  enterTo: 'opacity-100 translate-y-0 sm:scale-100',
  leave: 'transition ease-in duration-150',
  leaveFrom: 'opacity-100 translate-y-0 sm:scale-100',
  leaveTo: 'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95',
};

/** A panel docked on the right. */
export const slideTransition = {
  enter: 'transition ease-out duration-200',
  enterFrom: 'translate-x-full',
  enterTo: 'translate-x-0',
  leave: 'transition ease-in duration-150',
  leaveFrom: 'translate-x-0',
  leaveTo: 'translate-x-full',
};

/**
 * What an overlay shows, held while it closes: call sites often clear the
 * data behind it as they close it (open={Boolean(selected)}), which would
 * blank or break the content during the fade.
 */
export function useShownWhileOpen<T>(open: boolean, content: T): T {
  const shown = useRef(content);
  if (open) shown.current = content;
  return shown.current;
}
